<script lang="ts">
  import CTA from "@kontextwerk/web-sdk/ui/actions/CTA.svelte"
  import Icon from "@kontextwerk/web-sdk/ui/primitives/Icon.svelte"
  import type { DataRow } from "@kontextwerk/web-sdk/ui/layout/Table.svelte"
  import { mdiArchiveOutline, mdiArchiveArrowUpOutline } from "@mdi/js"
  import type { CustomerRow } from "../../_shared/_logic/customers-table-contract"
  import {
    CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS,
    customerRegistryActionTooltips,
  } from "../../../../../../_shared/_logic/customer-registry-action-tooltips"

  let {
    selectedRows = [],
    clearSelection,
    batchMutating = false,
    onMutateSelected,
  }: {
    selectedRows?: DataRow[]
    clearSelection: () => void
    batchMutating?: boolean
    onMutateSelected: (rows: DataRow[], clearSelection: () => void) => void | Promise<void>
  } = $props()

  const archivedCount = $derived(
    selectedRows.filter((row) => Boolean((row as CustomerRow).customer?.archived_at)).length,
  )
  const mixed = $derived(archivedCount > 0 && archivedCount < selectedRows.length)
  const restore = $derived(selectedRows.length > 0 && archivedCount === selectedRows.length)
</script>

<CTA
  type="secondaryButton"
  small={true}
  darkMode={false}
  content={restore ? "Auswahl wiederherstellen" : "Auswahl archivieren"}
  tooltipContent={mixed
    ? "Aktive und archivierte Ansprechpartner bitte getrennt auswählen."
    : restore
      ? customerRegistryActionTooltips.customerBatchRestore
      : customerRegistryActionTooltips.customerBatchArchive}
  tooltipClassName={CUSTOMER_REGISTRY_ACTION_TOOLTIP_CLASS}
  disabled={batchMutating || mixed}
  onClick={() => onMutateSelected(selectedRows, clearSelection)}
>
  {#snippet iconSnippet()}
    <Icon path={restore ? mdiArchiveArrowUpOutline : mdiArchiveOutline} />
  {/snippet}
</CTA>
